import { DEFAULT_TIMER } from "@/modules/irohana-components/constants/common";
import { useEffect, useRef } from "react";

export const useDebounce = (callback: () => void, deps: unknown[] = [], delay = DEFAULT_TIMER): void => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = setTimeout(() => callbackRef.current(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line
  }, [...deps, delay]);
};
